import { FC } from 'react';
import { Typography } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import './TeamRoleChip.scss';
import { getTeamRoleLabel } from '../i18n';

interface TeamRoleChipProps {
  role?: string;
  className?: string;
  uppercase?: boolean;
  pill?: boolean;
  label?: string;
}

const TeamRoleChip: FC<TeamRoleChipProps> = ({
  role,
  className,
  uppercase = false,
  pill = false,
  label,
}) => {
  const { t } = useTranslation();
  const resolvedLabel = label || getTeamRoleLabel(t, role);

  return (
    <Typography
      variant="subtitle2"
      component="span"
      className={clsx(
        'team-role-chip',
        'team-page__role-chip',
        role && `team-page__role-chip--${role}`,
        pill && 'team-page__role-chip--pill',
        className
      )}
    >
      {uppercase ? resolvedLabel.toUpperCase() : resolvedLabel}
    </Typography>
  );
};

export default TeamRoleChip;
